import React, { useEffect } from 'react';
import 'twin.macro';
import { Checkbox } from 'components/Form/Checkboxes/Checkbox';
import { CheckIcon } from '@heroicons/react/24/outline';

interface Props {
  value: boolean;
  onChange: (v: boolean) => any;
  readonly?: boolean;
  'aria-label'?: string;
}

export function Bool(props: Props) {
  const [v, setValue] = React.useState(props.value);
  useEffect(() => {
    if (props.value === v) return;
    setValue(props.value);
  }, [props.value]);

  if (props.readonly) {
    if (v)
      return (
        <>
          <CheckIcon tw="h-5 w-5" />
        </>
      );
  }

  return (
    <div>
      <Checkbox
        aria-label={props['aria-label']}
        onChange={() => {
          setValue(!v);
          props.onChange(!v);
        }}
        checked={!!v}
      />
    </div>
  );
}
